import { get } from 'lodash/fp';

export const selectEmployeeSpendingAccounts = get(
  'apps.employer-experience.employeeSpendingAccounts.accounts',
);

export const selectEmployeeSpendingAccountsReady = get(
  'apps.employer-experience.employeeSpendingAccounts.ready',
);
